import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const galleryImages = [
    // REAL TRANSFORMATIONS - Featured
    {
      id: 1,
      src: "/assets/images/fokp7nqo_IMG_5030.jpeg",
      alt: "Female Lifestyle Transformation - 3 Stage Progress",
      category: "transformations",
    },
    {
      id: 2,
      src: "/assets/images/b9jgchjb_IMG_5021.jpeg",
      alt: "Incredible Male Body Transformation",
      category: "transformations",
    },
    {
      id: 3,
      src: "/assets/images/wzept2r1_IMG_5027.jpeg",
      alt: "Bodybuilder Back Development",
      category: "transformations",
    },
    {
      id: 4,
      src: "/assets/images/9um8zu8e_IMG_5028.jpeg",
      alt: "Female Side Profile Transformation",
      category: "transformations",
    },
    {
      id: 5,
      src: "/assets/images/d75j8blz_IMG_5022.jpeg",
      alt: "Online Coaching Results - Male Physique",
      category: "transformations",
    },
    // COACHING
    {
      id: 6,
      src: "/assets/images/tyexuvmo_IMG_5009.jpeg",
      alt: "Chris Cormier Coaching - Intense Dumbbell Training",
      category: "coaching",
    },
    {
      id: 7,
      src: "/assets/images/r8ut5klc_97bbfbd7-848d-4077-96db-d146633a0a18.jpeg",
      alt: "Chris Cormier - Personal Training Session",
      category: "coaching",
    },
    {
      id: 8,
      src: "/assets/images/5spjl919_IMG_5008.jpeg",
      alt: "Female Athletes - Training with Chris",
      category: "coaching",
    },
    // CHRIS CORMIER
    {
      id: 9,
      src: "/assets/images/t2g7ml42_B84275DB-C91C-4358-8108-A1CA95B5E7D2.jpeg",
      alt: "Real Deal",
      category: "chris",
    },
    {
      id: 10,
      src: "/assets/images/yx5mgzoq_chris-cormier2.jpg.webp",
      alt: "Chris Cormier - FLEX Magazine",
      category: "chris",
    },
    {
      id: 11,
      src: "/assets/images/wqi96zl9_ChrisCormier_R_Reiff038-cropped.jpg.webp",
      alt: "Chris Cormier - Bicep Curls",
      category: "chris",
    },
    {
      id: 12,
      src: "/assets/images/7nqddb3u_PHOTO-2024-05-04-18-03-00.jpeg",
      alt: "Chris Cormier with Elite Bodybuilder",
      category: "chris",
    },
    // REAL DEAL BRAND
    {
      id: 13,
      src: "/assets/images/cx6byxpf_D238EFCF-4C3F-466B-B599-5C35CEF17BF2.png",
      alt: "Chris Cormier at Real Deal Supplements Booth",
      category: "brand",
    },
    {
      id: 14,
      src: "/assets/images/fhgusd0x_53740CA1-0B7D-4D1B-BF54-09E81778FCBC.jpeg",
      alt: "Real Deal Protein - Real Whey+ and Real Iso+",
      category: "brand",
    },
    {
      id: 15,
      src: "/assets/images/7j16upin_a3ee6479-6afe-4ea4-8d86-d7d7394c275d.jpeg",
      alt: "Real Deal Pre X3G No Stim Pre-Workout",
      category: "brand",
    },
    {
      id: 16,
      src: "/assets/images/xkse0j9n_FF3FD14D-5C97-422E-BA85-5440086805D9.png",
      alt: "Real Deal L-Carnitine, Multi V, Omega 3",
      category: "brand",
    },
    // MORE
    {
      id: 17,
      src: "/assets/images/kuz8nik5_b737a5c6-7c08-44b2-acbd-1e2b7cfcbeda.jpeg",
      alt: "Athlete Transformation - Competition Ready",
      category: "transformations",
    },
    {
      id: 18,
      src: "/assets/images/9i47ro1u_a466dcc8-b56b-47c6-869c-69fbcbd9562b.jpeg",
      alt: "Bodybuilder - Double Bicep Pose",
      category: "transformations",
    },
    {
      id: 19,
      src: "/assets/images/apn9wpqo_a858a127-811c-4164-b0bd-314283d740c5.jpeg",
      alt: "Female Bodybuilder Transformations",
      category: "transformations",
    },
    // CLIENT TRANSFORMATIONS — recent
    {
      id: 20,
      src: "/assets/images/a3yhh44c_IMG_5254.jpeg",
      alt: "Female Glute Transformation — 3 Stage Progress",
      category: "transformations",
    },
    {
      id: 21,
      src: "/assets/images/0sg8f647_IMG_5255.jpeg",
      alt: "Female Fat Loss Transformation — Front View",
      category: "transformations",
    },
    // CHRIS CORMIER — career & legacy
    {
      id: 22,
      src: "/assets/images/sco9klei_70751574-15f8-4e06-859d-68ae914ee5e9.jpeg",
      alt: "Ronnie Coleman vs Chris Cormier — Legendary Leg Battle",
      category: "chris",
    },
    {
      id: 23,
      src: "/assets/images/gcddunw7_3ca51a08-944f-4442-a5a7-a1c3fa8d4cd0.jpeg",
      alt: "Chris Cormier — Classic Backstage Pose",
      category: "chris",
    },
    {
      id: 24,
      src: "/assets/images/0a1kb2x7_b03e8c56-713b-473b-85e8-828085ff65a9.jpeg",
      alt: "Chris Cormier — 2005 Arnold Classic Stage Posing",
      category: "chris",
    },
  ];

  const [filter, setFilter] = useState("all");
  
  const filteredImages = filter === "all" 
    ? galleryImages 
    : galleryImages.filter(img => img.category === filter);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setSelectedImage(filteredImages[index]);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    const newIndex = (currentIndex + 1) % filteredImages.length;
    setCurrentIndex(newIndex);
    setSelectedImage(filteredImages[newIndex]);
  };

  const prevImage = () => {
    const newIndex = (currentIndex - 1 + filteredImages.length) % filteredImages.length;
    setCurrentIndex(newIndex);
    setSelectedImage(filteredImages[newIndex]);
  };

  const categories = [
    { id: "all", label: "All" },
    { id: "transformations", label: "Transformations" },
    { id: "coaching", label: "Coaching" },
    { id: "chris", label: "Chris Cormier" },
    { id: "brand", label: "Real Deal" },
  ];

  return (
    <div className="bg-black min-h-screen pt-24" data-testid="gallery-page">
      {/* Hero Section */}
      <section className="py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-16"
          >
            <p className="text-[#D4AF37] text-sm tracking-[0.3em] uppercase mb-4">Visual Journey</p>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-white mb-6" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
              GALLERY
            </h1>
            <p className="text-white/60 max-w-2xl mx-auto">
              Explore the world of Camp Cormier Academy. From intense training sessions to incredible transformations.
            </p>
          </motion.div>

          {/* Filter Tabs */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setFilter(cat.id)}
                className={`px-6 py-2 text-sm tracking-wider uppercase transition-all duration-300 ${
                  filter === cat.id
                    ? "bg-[#D4AF37] text-black"
                    : "border border-white/20 text-white/70 hover:border-[#D4AF37] hover:text-[#D4AF37]"
                }`}
                data-testid={`filter-${cat.id}`}
              >
                {cat.label}
              </button>
            ))}
          </div>

          {/* Gallery Grid */}
          <motion.div 
            layout
            className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"
          >
            <AnimatePresence mode="popLayout">
              {filteredImages.map((image, index) => (
                <motion.div
                  key={image.id}
                  layout
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.3 }}
                  className={`group relative cursor-pointer overflow-hidden bg-[#0A0A0A] ${
                    index === 0 ? "md:col-span-2 md:row-span-2" : ""
                  }`}
                  onClick={() => openLightbox(index)}
                  data-testid={`gallery-image-${image.id}`}
                >
                  <div className={`${index === 0 ? "aspect-square" : "aspect-square"}`}>
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                    <p className="text-white text-sm">{image.alt}</p>
                    <p className="text-[#D4AF37] text-xs uppercase tracking-wider mt-1">{image.category}</p>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>

      {/* Lightbox */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
            onClick={closeLightbox}
          >
            <button
              onClick={closeLightbox}
              className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors z-50"
              data-testid="lightbox-close"
            >
              <X size={32} />
            </button>

            <button
              onClick={(e) => { e.stopPropagation(); prevImage(); }}
              className="absolute left-6 text-white/70 hover:text-white transition-colors z-50"
              data-testid="lightbox-prev"
            >
              <ChevronLeft size={48} />
            </button>

            <button
              onClick={(e) => { e.stopPropagation(); nextImage(); }}
              className="absolute right-6 text-white/70 hover:text-white transition-colors z-50"
              data-testid="lightbox-next"
            >
              <ChevronRight size={48} />
            </button>

            <motion.img
              key={selectedImage.id}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="max-w-full max-h-[85vh] object-contain"
              onClick={(e) => e.stopPropagation()}
            />

            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-center">
              <p className="text-white text-lg">{selectedImage.alt}</p>
              <p className="text-white/50 text-sm mt-1">
                {currentIndex + 1} / {filteredImages.length}
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default GalleryPage;
